import { GridCardHits } from './GridCardHits';

export type { TypeGridCardHitsProps } from './types';
export default GridCardHits;
